import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import sharedStyles from '../WelcomeGuide.module.scss';
import styles from './Search.module.scss';
import { apiRequest, ApiRequestOptions } from '@support/api';
import { shuffleArray } from '@support/array';

const miscSearchHints = [
  'github',
  'tumblr',
  'instagram',
  'medium',
  'reddit',
  'youtube',
  'vimeo',
  'soundcloud',
  'facebook',
  'recently',
  'a while ago',
  'close',
  'closer',
  'closest',
];

const addlSearchHints = [
  'Art',
  'Travel',
  'Books',
  'TV',
  'Movies',
  'Museums',
  'Photography',
  'CAA',
  'Apple',
  'Mount Sinai',
  'NBC',
  'The New Yorker',
  'Nike',
  'Coca Cola',
  'NYC',
  'SF',
  'London',
  'Paris',
  'Shanghai',
  'Miami',
  'Boston',
  'California',
  'Texas',
  'Northeast',
  'South America',
  'Africa',
  'Asia',
  'Europe',
  'United States',
  'France',
  'Spain',
  'Canada',
  'China',
  'Japan',
  'India',
  'Egypt',
  'Malaysia',
];

export default function Search({ onClick }) {
  const [searchHints, setSearchHints] = useState(
    shuffleArray(miscSearchHints.concat(addlSearchHints)),
  );
  const hints = searchHints.map((hint) => (
    <div className={styles.hint} key={hint}>
      {hint}
    </div>
  ));

  const processHints = (hintLists) => {
    const extraHints = [...addlSearchHints];
    const personalizedHints = hintLists
      .reduce((hints, list) => {
        if (Array.isArray(list)) {
          return hints.concat(list.slice(0, 10).map(({ value }) => value));
        }
        return hints;
      }, miscSearchHints)
      .filter((hint, idx, arr) => arr.indexOf(hint) === idx);

    while (personalizedHints.length < 52) {
      personalizedHints.push(
        extraHints.splice(Math.round(Math.random() * (extraHints.length - 1)), 1),
      );
    }

    setSearchHints(shuffleArray(personalizedHints));
  };

  useEffect(() => {
    const opts: ApiRequestOptions = {
      skipApiVersion: true,
      noTimeZone: true,
    };
    Promise.all([
      apiRequest('GET', '/api/search/hints/locations.city', undefined, opts),
      apiRequest('GET', '/api/search/hints/locations.region', undefined, opts),
      apiRequest('GET', '/api/search/hints/organizations.name', undefined, opts),
      apiRequest('GET', '/api/search/hints/interests.n', undefined, opts),
    ]).then(processHints);
  }, []);

  return (
    <div className={cn(sharedStyles.page, sharedStyles.numberedPage)} onClick={onClick}>
      <div className={cn(sharedStyles.pageContent, sharedStyles.left)}>
        <h2>Search</h2>
        <p>
          Find the person you’re thinking of, every time. Next time you’re trying to remember
          someone or something, don’t worry about getting it exactly right.
        </p>
        <p>
          Search for whatever you can remember, and let Clay do the rest—pulling from notes, job
          history, and more behind the scenes to find just what you’re looking for across everyone
          you know.
        </p>
      </div>
      <div className={styles.searchHints}>
        <div className={styles.hintsContainer}>{hints}</div>
        <div className={cn(styles.hintsContainer, styles.zoomed)}>{hints}</div>
      </div>
      <div className={sharedStyles.pageNumber}>03 — Search</div>
    </div>
  );
}
